import EmberDataCache from 'cpc-license-manager/utils/ember-data-cache';
import BaseStore, { CacheHandler } from '@ember-data/store';
import RequestManager from '@ember-data/request';
import Fetch from '@ember-data/request/fetch';
import { buildSchema, modelFor, instantiateRecord, teardownRecord } from '@ember-data/model';
import {
  adapterFor,
  LegacyNetworkHandler,
  normalize,
  pushPayload,
  serializeRecord,
  serializerFor,
} from '@ember-data/legacy-compat';

export default class Store extends BaseStore {
  constructor(args) {
    super(args);
    this.requestManager = new RequestManager();
    this.requestManager.use([LegacyNetworkHandler, Fetch]);
    this.requestManager.useCache(CacheHandler);
  }

  createCache(capabilities) {
    return new EmberDataCache(capabilities);
  }

  createSchemaService() {
    return buildSchema(this);
  }

  instantiateRecord(key, createRecordArgs) {
    return instantiateRecord.call(this, key, createRecordArgs);
  }

  teardownRecord(record) {
    return teardownRecord.call(this, record);
  }

  modelFor(type) {
    return modelFor.call(this, type) || super.modelFor(type);
  }

  adapterFor = adapterFor;
  serializerFor = serializerFor;
  pushPayload = pushPayload;
  normalize = normalize;
  serializeRecord = serializeRecord;
}
